export const saveFile = (data, fileName, mimeType = null) => {
    try {
        const byteArray = new Uint8Array(data);
        /* Package data as Blob for download. See:
            - https://stackoverflow.com/questions/3665115/how-to-create-a-file-in-memory-for-user-to-download-but-not-through-server
            - https://developer.mozilla.org/en-US/docs/Web/API/Blob)
        */
        if (mimeType == null) {
            mimeType = "application/octet-stream"
        }
        const blob = new Blob([byteArray], {
            type: mimeType
        })

        // Trigger the download using a temporary link
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName // Set the file name
        document.body.appendChild(link)
        link.click();

        // Clean up by removing the link and revoking the object URL
        link.remove();
        URL.revokeObjectURL(link.href)
    } catch (error) {
        console.error("utils.saveFile Exception: ", error.message);
        throw error
    }
}

export const fileToBinaryString = async function (file) {
    return new Promise((resolve, reject) => {
        try {
            const reader = new FileReader();
            reader.onload = (e) => {
                resolve(e.target.result);
            }
            reader.onerror = (e) => {
                reject(e);
            }
            reader.readAsBinaryString(file);
        } catch (x) {
            console.trace(x.toString())
            window.alert(x.toString())
        }
    })
}

/**
 * Return a string encoding the files as multipart form data. Useful for intercepting a submit event on a form that uploads files.
 * @param {string} boundary : for separating request body segments
 * @param {object} files : associative array that maps form input name attributes to HTML5 File objects, e.g. {file1:<File>, file2:<File>}
 */
export const multipartFormDataEncodeFiles = async function (boundary, files) {
    try {
        let encoded = "";
        for (const inputName of Object.keys(files)) {
            let file = files[inputName];
            if (!(file instanceof File)) {
                throw new Error("file with name attribute \"".concat(inputName).concat("\" is not a File"));
            }
            let contents = await fileToBinaryString(file);
            encoded = encoded.concat(`${boundary}
Content-Disposition: form-data; name="Content-Type"

${file.type}
${boundary}
Content-Disposition: form-data; name="${inputName}"; filename="${file.name}"
Content-Type: ${file.type}

${contents}
`);
        }
        encoded = encoded.concat(`${boundary}--
`);
        return encoded
    } catch (x) {
        console.trace(x.toString())
        window.alert(x.toString())
    }
}

export const uploadFileToPresignedURL = async function (file, url) {
    const f = "uploadFileToPresignedURL"
    //console.log(f.concat(": about to fetch from url \"").concat(url).concat("\""))
    return await fetch(url, {
        method: 'PUT',
        headers: {
            //'Access-Control-Allow-Headers': "Accept, Content-Type, Origin, X-Requested-With",
            //'Access-Control-Allow-Allow-Methods': "GET, POST, PUT",
            //'Access-Control-Allow-Origin': '*',
            'Content-Type': file.type
        },
        body: file
    }).then(
        (response) => {
            if (response.ok) {
                console.log(f.concat(": Successfully uploaded file to presigned URL"))
                return response
            }
            else {
                const error = new Error(`Failed to upload file to presigned URL. Status: ${response.statusText}`)
                error.code = response.status
                throw error
            }
        }
    ).catch(
        (error) => {
            throw error
        }
    )
}